import slugify from 'slugify'

export class CommonLinkService {
  scopeToReviewer: boolean

  constructor (scopeToReviewer = true) {
    this.scopeToReviewer = scopeToReviewer
  }

  public slugify (str: string): string {
    return slugify(str, {
      strict: true // strip special characters except replacement
    })
  }

  public adminLink (...parts: any[]) {
    return '/' + parts.join('/')
  }

  public adminList (module: string) {
    const translatedModuleName = this.translateModule(module + 's')
    return this.adminLink(translatedModuleName)
  }

  public adminUpdate (module: string, id: any) {
    const translatedModuleName = this.translateModule(module)
    return this.adminLink(translatedModuleName, 'update', id)
  }

  public adminView (module: string, id: any) {
    const translatedModuleName = this.translateModule(module)
    return this.adminLink(translatedModuleName, 'view', id)
  }

  public adminDelete (module: string, id: number) {
    return this.adminLink(module, 'delete', id)
  }

  public adminCreate (module: string) {
    const translatedModuleName = this.translateModule(module)
    return this.adminLink(translatedModuleName, 'create')
  }

  translateModule (module: string, ...params: any[]) {
    switch (module) {
      case 'arc': return this.scopeToReviewer ? 'review-copy' : 'review-campaign'
      case 'arcs': return this.scopeToReviewer ? 'review-copies' : 'review-campaigns'
      case 'arc-team': return 'team'
      case 'arc-teams': return 'teams'
      case 'your-arcs': return 'my-review-copies'
      default: return module
    }
  }

  public frontEndRelative (module: string, ...params: any[]) {
    const translatedModuleName = this.translateModule(module, params)
    return ['', translatedModuleName].concat(params.map(m => this.slugify(m.toString().toLowerCase()))).join('/')
  }

  public addSearch (link: string, searchFor: string) {
    return `${link}#?needle=${encodeURIComponent(searchFor)}`
  }

  public addAnchor (url: string, anchor: string) {
    const newUrl = url.substring(0, url.indexOf('#')) || url
    return `${newUrl}#${anchor}`
  }
}
